import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHashElement = ({ offset = 172 }: { offset?: number }) => {
  const location = useLocation();

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    const effectiveOffset = isMobile ? 85 : offset;

    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - effectiveOffset,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location, offset]);

  return null;
};

export default ScrollToHashElement;
